import { constructRequestDetails } from 'src/hooks/useFetch';

function printPdfWithViewer(endpointURLKey: string, options: any = {}, blobType: string) {
  fetch(constructRequestDetails(endpointURLKey, options).url, {
    headers: { ...constructRequestDetails(endpointURLKey, options).headers }
  })
    .then(res => res.blob())
    .then(blobData => {
      const url = window.URL.createObjectURL(new Blob([blobData], { type: blobType }));
      const iframe: any = document.createElement('iframe');
      iframe.className = 'pdfIframe';
      document.body.appendChild(iframe);
      iframe.style.display = 'none';
      if (iframe !== null) {
        iframe.onload = () => {
          setTimeout(function () {
            iframe.focus();
            iframe.contentWindow.print();
            URL.revokeObjectURL(url);
          }, 1);
        };
        iframe.src = url;
      }
    });
}

export default printPdfWithViewer;
